import { render, staticRenderFns } from "./ResultsAndReports.vue?vue&type=template&id=ceaf2c8c&scoped=true&"
import script from "./ResultsAndReports.vue?vue&type=script&lang=js&"
export * from "./ResultsAndReports.vue?vue&type=script&lang=js&"
import style0 from "./ResultsAndReports.vue?vue&type=style&index=0&id=ceaf2c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaf2c8c",
  null
  
)

export default component.exports